import { ComponentProps } from 'react';
import { bordColorTheme, nudosYellow200 } from '../../../../styles/styles.constants';

const BordTriangleAlertCircle = (props: ComponentProps<'svg'>) => {
  const { stroke, fill } = props;
  return (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="48" rx="24" fill={fill || bordColorTheme.yellow[100]} />
      <path
        d="M10.8682 31.9531L19.8943 13.5247C21.5665 10.1106 26.4329 10.1106 28.1051 13.5247L37.1311 31.9531C37.5266 32.76 37.8415 33.666 37.036 34.3079C33.2495 37.3259 14.7498 37.3259 10.9633 34.3079C10.1568 33.6651 10.4687 32.7684 10.8682 31.9531Z"
        fill="white"
        stroke={stroke || nudosYellow200}
        strokeLinejoin="round"
      />
      <path d="M24 19.4285V25.1428M24 30.2856V30.857" stroke={stroke || nudosYellow200} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default BordTriangleAlertCircle;
